
  export function getBucketLink() {
    return "https://quasar-edtech-stream.s3.amazonaws.com/";
  }

  export function getImageBucketLink() {
    return "https://quasaredtech-adminuploads.s3.amazonaws.com/";
  }

